import React from 'react';
import LoadingSkeleton from '../Shared/LoadingSkeleton'; // Import Skeleton

// Added proofs (data), isLoading, and error props
const ProofSection = ({ proofs = [], isLoading, error }) => {
  return (
    <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-lg transition-medium transform-gpu hover:scale-[1.01] border border-dark-400 hover:border-dark-300 min-h-[250px] flex flex-col">
      <div className="flex items-center mb-5 flex-shrink-0">
        <h3 className="font-bold text-lg flex items-center">
          <i className="fas fa-check-circle mr-2 text-accent-green opacity-80"></i>
          Proof of Effectiveness
           {isLoading && <i className="fas fa-spinner fa-spin text-xs ml-2 text-gray-400"></i>}
        </h3>
      </div>
      <div className="flex-1 space-y-3 pr-2 overflow-y-auto custom-scrollbar">
        {isLoading ? (
             <LoadingSkeleton count={4} />
         ) : error ? (
             <p className="text-center text-accent-red text-sm py-8">{error}</p>
        ) : proofs.length === 0 ? (
            <p className="text-gray-400 text-center py-8">No proofs available</p>
        ) : (
          proofs.map((proof, index) => (
            <a
              href={proof.link}
              target="_blank"
              rel="noopener noreferrer"
              key={index}
              className="flex items-center p-3 bg-dark-500 rounded-xl hover:bg-dark-400 transition-medium cursor-pointer group transform-gpu hover:-translate-y-1 hover:shadow-md"
            >
              <div className="w-24 h-16 rounded-lg overflow-hidden mr-3 relative flex-shrink-0">
                <img src={proof.thumbnail} alt={proof.title} className="w-full h-full object-cover transition-medium group-hover:scale-110" />
                <div className="absolute inset-0 flex items-center justify-center bg-dark-800 bg-opacity-50 opacity-0 group-hover:opacity-100 transition-medium">
                  <i className="fas fa-play text-white"></i>
                </div>
              </div>
              <div className="flex-1 overflow-hidden"> {/* Added overflow-hidden */}
                <p className="font-medium group-hover:text-white transition-colors text-sm truncate">{proof.title}</p> {/* Added truncate */}
                <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-colors">
                  <i className="fas fa-eye mr-1"></i> {proof.views} views
                </p>
              </div>
            </a>
          ))
        )}
      </div>
    </div>
  );
};

export default ProofSection;